module.exports = __webpack_public_path__ + "static/media/cp83.87fa878e.jpg";